// Produits renommés : une ancienne adresse ou un ancien lien de paiement
// (ex. /bot/vantaphone-tphone) mène au produit actuel.
export const PRODUCT_ALIASES = {
  "vantaphone-tphone": "vantaphone-yphone",
  "vantaphone-sphone": "vantaphone-yphone",
};

export const currentProductId = (id) => PRODUCT_ALIASES[id] || id;
